import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginRequest } from 'src/app/demo/api/login-request';
import { ROLES } from 'src/app/demo/constants/roles.constant';
import { AuthService } from 'src/app/demo/service/auth.service';
import { EventService } from 'src/app/demo/service/event.service';
import { NotificationService } from 'src/app/demo/service/notification.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [`
        :host ::ng-deep .pi-eye,
        :host ::ng-deep .pi-eye-slash {
            transform:scale(1.6);
            margin-right: 1rem;
            color: var(--primary-color) !important;
        }
    `]
})
export class LoginComponent implements OnInit {
    loginRequest = {} as LoginRequest;
    username: string;
    password: string;
    isLoading: boolean = false;

    valCheck: string[] = ['remember'];
    forgetPasswordDialog: boolean = false;

    forgetPasswordForm: FormGroup;

    constructor(public layoutService: LayoutService, 
        private authService: AuthService, 
        private messageService: MessageService,
        private router: Router,
        private fb: FormBuilder,
        private eventService: EventService,
        private notificationService: NotificationService,
    ) 
    {
        this.forgetPasswordForm = this.fb.group({
            username: ['',Validators.required],
            email: ['', [Validators.required, Validators.email]]
        });
    }

    ngOnInit() {
        // this.loginRequest = {} as LoginRequest;
    }

    // login() {
    //     // this.loginRequest.username = 'test';
    //     // this.loginRequest.password = 'test';
    //     // // console.log(this.username);
    //     // console.log(this.loginRequest);
    //     // // console.log('test');
    //     this.loginRequest.username = this.username;
    //     this.loginRequest.password = this.password;
    //     console.log(this.loginRequest);
    //     this.authService.login(this.loginRequest).subscribe(
    //         () => this.router.navigate(['/acknownledgment']),
    //         err => console.error(err)
    //     );
    // }

    login() {
        this.loginRequest.username = this.username;
        this.loginRequest.password = this.password;
        this.isLoading = true;
        this.authService.login(this.loginRequest).subscribe({
            next: (data) => {
                // alert(data.token);
                this.isLoading = false;
                // this.notificationService.startConnection(data.token);
                // this.notificationService.addNotificationListener();
                if (data.user.roleId === ROLES.DISPOSER) {
                    this.eventService.setIsAccept(false);
                    this.router.navigate(['/acknownledgment']);
                } else {
                    this.eventService.setIsAccept(true);
                    this.router.navigate(['/info']);
                }
            },
            error: (error) => {
                this.isLoading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
            }
        }
        );
    }

    showDialog(){
        this.forgetPasswordDialog = true;
    }

    submitForget() {
        if (this.forgetPasswordForm.valid) {
            const userData = {
                username: this.forgetPasswordForm.get('username').value,
                email: this.forgetPasswordForm.get('email').value,
            }
            this.isLoading = true;

            this.authService.forgetPassword(userData).subscribe({
                next: (data) => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: `Change password link has been sent to your email` });
                    this.onCancel();
                    this.isLoading = false;
                },
                error: (error) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
                    this.isLoading = false;
                }
            })
            console.log(userData)
        }
    }

    onCancel() {
        this.forgetPasswordForm.reset();
        this.forgetPasswordDialog = false;
        this.isLoading = false;
    }
}
